import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TimesheetAccessService } from '../components/timesheet-mangement/timesheet-access.service';

/**
 * Blocks `/dashboard/timesheet/manage-timesheet` when the feature flag is off or
 * the user lacks Manage Timesheet permission (submodule 47 / manage).
 */
export const manageTimesheetGuard: CanActivateFn = () => {
  const router = inject(Router);
  const timesheetAccess = inject(TimesheetAccessService);
  timesheetAccess.refresh();
  if (timesheetAccess.canOpenManageTimesheet()) {
    return true;
  }
  const fallback = timesheetAccess.firstAccessibleChildPath('manage-timesheet');
  if (fallback) {
    return router.createUrlTree(['/dashboard', 'timesheet', fallback]);
  }
  return router.createUrlTree(['/dashboard', 'home']);
};
